import type { MetricInfo, MetricInfoId, SectionType } from '@az3fr/core';

import { sectionTypeDisplayInfos } from '@/entities/section-plan/model/section-type';

/**
 * Determines if another step can be added to a section based on the section type and current step count
 */
function canAddAnotherStep(sectionType: SectionType, stepsCount: number) {
	return stepsCount < sectionTypeDisplayInfos[sectionType].coreModel.rules.maxSteps;
}

/**
 * Checks if a metric is currently being tracked
 */
function isTrackedMetric(trackedMetrics: MetricInfo[], metricId: MetricInfoId) {
	return trackedMetrics.some((trackedMetric) => trackedMetric.id === metricId);
}

export { canAddAnotherStep, isTrackedMetric };
